/**
 * Ficha aberta na mesa (system/charSheet; FC.Room.UIModule.CharacterSheetModule):
 * o item da biblioteca diz o tipo de dado, e o plugin web da mesa que edita esse tipo
 * mostra a ficha num iframe (docs/spec/web-plugins.md), ligada ao NDB dela.
 */
import { useT } from '../i18n/index.js';
import { useApp } from '../store.js';
import { pluginForDataType } from './pluginHost.js';
import { WebPluginFrame } from './web/WebPluginFrame.js';
import './plugins.css';

/** Ficha ou tabela de plugin. */
export function SheetModule({ itemId }: { itemId: string }) {
  const t = useT();
  const item = useApp((s) => s.library.find((i) => i.id === itemId));
  // o mestre ocultou a ficha aberta (BRAZ-16): um bloco preto até ela voltar
  const hidden = useApp((s) => s.hiddenLibrary.includes(itemId));
  const plugin = pluginForDataType(useApp((s) => s.plugins), item?.dataType ?? null);
  if (hidden) return <div className="rd-module__hidden" role="img" aria-label={t('library.notVisible')} />;
  if (!item) return <div className="rd-module__placeholder">{t('sheet.gone')}</div>;
  if (!plugin) return <div className="rd-module__placeholder">{t('sheet.noPlugin', { type: item.dataType ?? '?' })}</div>;
  return <WebPluginFrame plugin={plugin} item={item} />;
}
